// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".menu-mediclub[data-v-f10110a4]{flex-direction:column;gap:var(--spacing-sm-1)}.menu-mediclub__icon-text[data-v-f10110a4]{display:none}@media(min-width:768px){.menu-mediclub__icon-text[data-v-f10110a4]{display:block}}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
